/**
 * Observes lane visibility using IntersectionObserver.
 *
 * @property {import('vue').Component} component - The Vue component instance.
 * @property {IntersectionObserver|null} visibilityObserver - The IntersectionObserver instance.
 * @method observeVisibility - Initializes the observer and binds visibility updates.
 * @method disconnect - Stops the observer.
 */
export default class LaneVisibilityObserver {
	constructor(component) {
		this.component = component;
		this.observeVisibility();
	}

	observeVisibility() {
		const observerOptions = {
			root: null,
			rootMargin: '0px',
			threshold: 0,
		};

		this.visibilityObserver = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (this.component.autoscroll) {
					this.component.autoscroll.handleVisibilityChange(entry.isIntersecting);
				}
			});
		}, observerOptions);

		this.visibilityObserver.observe(this.component.$el);
	}

	disconnect() {
		if (this.visibilityObserver) {
			this.visibilityObserver.disconnect();
		}
	}
}
